import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import INotificationMessage = ZoneIQCalibration.INotificationMessage;
import { environment } from '../../../environments/environment';
import { map, tap } from 'rxjs/operators';
import { NotificationMessageModel } from 'src/app/models/common-models/notification-message.model';
import { NotificationMessageType } from 'src/shared/enums/notification-message-type.enum';

const API = environment.ZONEIQ_CALIBRATION + '/v1/notification-messages';

@Injectable({
    providedIn: 'root'
})
export class NotificationMessageService {
    notificationMessagesByType = new Map<number, INotificationMessage>(null);

    constructor(private readonly http: HttpClient) {}

    getAll() {
        return this.http.get<Response>(API).pipe(
            map(response => this.initNotificationMessages((response as any).data)),
            tap(notificationMessages => {
                this.notificationMessagesByType = notificationMessages;
            })
        );
    }

    private initNotificationMessages(notificationMessages: INotificationMessage[]): Map<number, INotificationMessage> {
        const messagesMap = new Map<number, INotificationMessage>();
        notificationMessages.forEach(message => {
            const messages = NotificationMessageModel.factory(message);
            messagesMap.set(message.Type, messages);
        });
        return messagesMap;
    }

    getByType(type: NotificationMessageType) {
        return this.notificationMessagesByType.get(type);
    }

    getMessageByType(type: NotificationMessageType) {
        return _.get(this.getByType(type), 'Message');
    }
}
